var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticStyle:{"cursor":"help"},attrs:{"color":_vm.data.color,"dark":""}},on),[_vm._v(_vm._s(_vm.data.icon))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.data.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }